export default __webpack_public_path__ + "static/media/SensorFootRight.71f254bc.svg";